module.exports = __webpack_public_path__ + "img/big4-2.2ceda76f.jpg";